import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";

import noMessageImage from "../../../image/profile/no-message.svg";
import { messageApi, setMessagesAsReadApi } from "../../../utility/api/apiList";

import userMessageType from "../../../redux/actions/userMessage/userMessageType";

import useAxios from "../../../hooks/useAxios";
import useFilter from "../../../hooks/useFilter";
import scrollToTop from "../../../libs/scrollToTop";
import { calculatePageSize } from "../../../libs/pagingDetail";

import LoadingComponent from "../../../components/public/loading";
import PaginationComponent from "../../../components/public/pagination";
import UserMessageComponent from "../../../components/private/user/userMessageComponent";

import EmptyListErrorComponent from "../../../components/public/error/emptyListErrorComponent";

import {
  ContainerMessageFilters,
  MessageFilterButton,
} from "./styledUserMessageContainer";

const UserMessageContainer = () => {
  const dispatch = useDispatch();
  const { onChange, filterState } = useFilter();

  const [filterValue, setFilterValue] = useState("");
  const messagesPageSize = filterState["page_size"] || 10;
  const userRole = useSelector((state) => state.userDetail.userRole);

  const ListFilterUserMessage = [
    {
      title: "همه پیام‌ها",
      value: "",
    },
    {
      title: "اطلاع‌رسانی",
      value: "1",
    },
    {
      title: "تراکنش‌ها",
      value: "2",
    },
    {
      title: "امتیازها",
      value: "3",
    },
    {
      title: userRole === "student" ? "پیام‌های معلم" : "پیام‌های دانش‌آموز",
      value: "4",
    },
  ];

  const getMesssgesDefaultParams = {
    order_by: "-id",
    page: filterState["page"] || 1,
    page_size: messagesPageSize,
    filter_type: filterValue,
  };

  const {
    data: messages,
    error: messagesError,
    isLoading: messagesLoading,
    isLoaded: messagesIsLoaded,
    run: messagesRun,
  } = useAxios({
    url: messageApi,
    params: getMesssgesDefaultParams,
  });

  useEffect(() => {
    document.title = "پیام‌های من";
    scrollToTop();
    axios.get(setMessagesAsReadApi).then(() => {
      dispatch({ type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE });
    });
  }, []);

  useEffect(() => {
    messagesRun();
  }, [filterState["page"]]);

  const handleFilterMessage = (value) => {
    messagesRun(undefined, { ...getMesssgesDefaultParams, filter_type: value });
    setFilterValue(value);
    onChange("page", 1);
  };

  let element = null;
  if (messagesLoading) {
    element = <LoadingComponent />;
  } else if (messagesError) {
    element = (
      <p className="text-center p-5">
        متاسفانه مشکلی پیش آمده، لطفا بعدا دوباره امتحان کنید.
      </p>
    );
  } else if (messages?.results?.length === 0) {
    element = (
      <EmptyListErrorComponent
        errorMessage="هیچ پیامی برای شما وجود ندارد."
        errorMessageImg={noMessageImage}
      />
    );
  } else {
    element = messages?.results?.map((item) => {
      return (
        <UserMessageComponent
          key={item.id}
          message={item}
          userRole={userRole}
          messagesIsLoaded={messagesIsLoaded}
        />
      );
    });
  }

  return (
    <>
      <ContainerMessageFilters>
        {ListFilterUserMessage.map((item) => (
          <MessageFilterButton
            key={item.title}
            onClick={() => {
              handleFilterMessage(item.value);
            }}
            active={item.value === filterValue}
          >
            {item.title}
          </MessageFilterButton>
        ))}
      </ContainerMessageFilters>

      {element}

      {!messagesLoading && (
        <>
          {messages?.results?.length !== 0 && (
            <PaginationComponent
              pageNumber={calculatePageSize(
                messages?.count,
                filterState["page_size"]
              )}
              currentPage={filterState["page"] || 1}
              handleChangePage={(e, value) => {
                onChange("page", value);
              }}
              className="mt-5"
              defaulPage={1}
            />
          )}
        </>
      )}
    </>
  );
};

export default UserMessageContainer;
